import axios from 'axios';
import config from 'commons-vehicle/config/index.js';
import { isArray, join } from 'lodash';
import { LocaleService, ConfigsService } from '@sm360/widget-commons-core-services';

/**
 * Groups Vehicle api calls to ShowroomAPI
 */
class VehicleAPIService {
    constructor() {
        /**
         * The base path for Vehicle ShowroomAPI
         * @type {string}
         */
        this.basePath = `${config.endpoint.showroom}/service/v1/Vehicles`;

        /**
         * The auth queryParams to call ShowroomAPI as a public user
         * @type {string}
         */
        this.publicAuthParams = 'userName=public&password=public';
    }

    /**
     * Gives the vehicles details from a list of ids
     * @param {string[]} vehicleIds
     */
    findVehicleByIds(vehicleIds) {
        if (!isArray(vehicleIds)) {
            throw new TypeError('param [vehicleIds] must be an array');
        }
        const location = ConfigsService.getOrganizationUnitLocation();
        const language = LocaleService.getLocale();
        const organizationId = ConfigsService.getOrganizationId();
        const organizationUnitId = ConfigsService.getOrganizationUnitId();

        // old `dataLevel=3` indicated the payment without any items
        // 'dataLevel=19' indicates that we include all items (options, dealer items) in the payment
        const url = `${
            this.basePath
        }?language=${language}&location=${location}&refresh=1&datalevel=19&context=${organizationId}.${organizationUnitId}&${
            this.publicAuthParams
        }`;

        return axios
            .post(url, vehicleIds)
            .then((result) => result.data)
            .catch(() => {
                console.error(`Unable to get vehicle details for ids [${join(vehicleIds)}]`);
                return Promise.reject();
            });
    }
}

export { VehicleAPIService };
export default new VehicleAPIService();
